import { Card } from '@nextui-org/react';
import Image from 'next/image';
import Link from 'next/link';

const tapTarget = 'md:p-0 p-2';

export default function Footer() {
  return (
    <Card className="mt-auto footer p-10 md:text-base text-lg" role="complementary">
      <div>
        <Image alt="weigh-scale" height={60} src="https://img.icons8.com/3d-fluency/94/null/scales.png" width={60} />
        <p>
          <span className="text-2xl font-bold">Thaqalayn</span>
          <br />
          Serving مؤمنین since 2019
        </p>
        <p className="md:text-xs text-base">
          By using our website, you hereby consent to our
          <Link className="text-blue-700" href="/privacy" scroll={false}>
            {' Privacy Policy '}
          </Link>
          and agree to its terms.
        </p>
      </div>
      <div>
        <span className="footer-title"></span>
      </div>
      <div>
        <span className="text-gray-700 font-semibold">More</span>
        <Link className={tapTarget} href="/about" scroll={false}>
          About us
        </Link>
        <Link className={tapTarget} href="/donate" scroll={false}>
          Donate
        </Link>
        <Link className={tapTarget} href="https://twitter.com/ThaqalaynNet" scroll={false}>
          Twitter
        </Link>
        <Link className={tapTarget} href="/grading-info" scroll={false}>
          About Gradings
        </Link>
        <Link className={tapTarget} href="/privacy" scroll={false}>
          Privacy Policy
        </Link>
      </div>
      <div>
        <span className="text-gray-700 font-semibold">Additional Resources</span>
        <a className={tapTarget} href="https://www.quranesk.com/" rel="noreferrer" target="_blank">
          Quranesk.com
        </a>
        <a className={tapTarget} href="https://almizan.org/" rel="noreferrer" target="_blank">
          Tafsir Al-Mizan
        </a>
        <a className={tapTarget} href="https://al-islam.org" rel="noreferrer" target="_blank">
          Al-Islam
        </a>
        <a className={tapTarget} href="https://wikishia.net" rel="noreferrer" target="_blank">
          WikiShia
        </a>
      </div>
    </Card>
  );
}
